import React, { Fragment, useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
const getOption = (legends, labels, data) => {

    return {
        title: {
            text: ''
        },
        tooltip: {
            trigger: 'axis'
        },
        legend: {},
        grid: {
            left: '1%',
            right: '2%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: labels
        },
        yAxis: {
            type: 'value',
            axisLabel: {
                margin: 40,
            }
        },
        series: data,
    };
}
const LineCore = ({legends, labels, data}) => {

    const [option, setOption] = useState(null);
    const onChartReady = (echarts) => {
        echarts.hideLoading();
    }
    useEffect(()=>{
        // console.log(" dataInnnn",data );

        setOption(getOption(legends, labels, data));
    }, [data])

    return (
        <Fragment>
            { option != undefined &&
                <ReactECharts
                    option={option}
                    style={{ height: 300 }}
                    onChartReady={onChartReady}
                />
            }
        </Fragment>
    )
}

export default LineCore;